/**
 * Determines whether the content for a given route should be centered.
 *
 * @param currentRoute - The current route string to check.
 * @param routes - An array of route strings that require centered content.
 * @returns True if the current route is in the list of routes to be centered, false otherwise.
 */
export const shouldCenterContent = (currentRoute: string, routes: string[]): boolean => {
  return routes.includes(currentRoute);
};
